(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8708],{

/***/ 58708:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ expressdelivery; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/assets/images/Plane-Animation-Desktop.gif
/* harmony default export */ var Plane_Animation_Desktop = ({"src":"/_next/static/media/Plane-Animation-Desktop.3b2bbdc6.gif","height":160,"width":1920});
// EXTERNAL MODULE: ./src/styles/home.module.scss
var home_module = __webpack_require__(31966);
var home_module_default = /*#__PURE__*/__webpack_require__.n(home_module);
;// CONCATENATED MODULE: ./src/components/home/expressdelivery.tsx






var Expressdelivery = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            className: (home_module_default()).bg_express,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/jewellery/category/all-products?fastDelivery=true",
                passHref: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: Plane_Animation_Desktop,
                    className: "w-100"
                })
            })
        })
    });
};
/* harmony default export */ var expressdelivery = (Expressdelivery);


/***/ }),

/***/ 31966:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"bg_express":"home_bg_express__WD7_h","express":"home_express__T_WnA","exp_img":"home_exp_img__agoJw","express_head":"home_express_head__nGiJ8","express_head_text":"home_express_head_text__YQ0kF","headline":"home_headline__tijze","headline1":"home_headline1__luiMd","shipping":"home_shipping__G0FPk","exp_text":"home_exp_text__leR9I","easy_button":"home_easy_button__nRxp_","shop_btn":"home_shop_btn__h_3lR","icon_w":"home_icon_w__HEFIp","active":"home_active__XYzHK","icon1":"home_icon1__LT0b_","icon2":"home_icon2__Pemgr","icon3":"home_icon3__s4nyS","icon4":"home_icon4__4RN_k","icon5":"home_icon5__lWkzT","icon6":"home_icon6__huGtL","icon7":"home_icon7__e_O2Z","icon8":"home_icon8__sgkHy","icon9":"home_icon9__xQQcb","icon10":"home_icon10__kW0Qu","col_clg_3":"home_col_clg_3__z_rKc","container":"home_container__vghhx"};

/***/ })

}]);